<div class="imageWrapper">
  @if (modelImagePath() && modelImagePath().length > 0) {
    <img class="modelImage" [src]="modelImagePath()" alt="UnitImage"/>
  }
</div>
<div class="skusWrapper">
  <app-lead-time-row [entityLeadTime]="entityLeadTime()" [configurationLeadTime]="configurationLeadTime()">
  </app-lead-time-row>
  @if (uniqueMessages().length > 0) {
    <button matButton="elevated" class="messagesButton" (click)="showMessages()">
      Messages
    </button>
  }
  <div class="skuTableWrapper">
    @if (skus()) {
      <table class="alternateColors reportTable">
        @for (sku of skus(); track sku) {
          <tr [class.overridden]="isOverridden(sku)">
            <td class="tableCell">{{ sku.description }}</td>
            <td class="tableCell rightAligned">{{ getSkuPrice(sku) | currency: 'USD' }}</td>
          </tr>
        }
        @for (sfr of sfrEntries(); track sfr) {
          <tr>
            <td class="tableCell">
              <input class="sfrIgnoreCheckbox" type="checkbox" [checked]="!sfr.ignore" (change)="ignoreFlagChanged(sfr)"
                id="{{sfr.sfrNumber + 'ignoreCheckbox'}}">
              <label for="{{sfr.sfrNumber + 'ignoreCheckbox'}}">{{ sfr.sfrNumber + ' ' + sfr.description }}</label>
            </td>
            <td class="tableCell rightAligned">{{ getSfrPrice(sfr) | currency: 'USD' }}</td>
          </tr>
        }
      </table>
    }
  </div>
  @if (skus()) {
    <div class="skuFooter">
      <span class="spacer"></span>
      <label class="totalPriceLabel">{{ 'Total Price: ' + (getTotalPrice() | currency: 'USD') }}</label>
    </div>
  }
</div>
